import React from 'react'
import TabsProvider from '../tabs-provider'

const ShowProduct = ({ params: { productId }, location, children }) => (
  <div>
    <TabsProvider
      pathname={location.pathname}
      tabs={[{
        label: 'Edit Products',
        path: `/ecommerce/products/${productId}/edit`
      }]}
    />
    {children}
  </div>
)

export default ShowProduct
